<template>
  <div>
    <div class="row no-wrap items-center">
      <default-checkbox :value="agreeToReceiveMailFromMeitav" v-on="$listeners" customClass="self-start">
        <div class="row now-wrap">
          <div>
            <span>אני מסכימ.ה לקבל הצעות נוספות של מוצרים ושירותים פיננסיים אחרים </span>
            <span class="text-riseup-blue r-text-bold">לא חובה</span>
          </div>
        </div>
      </default-checkbox>
      <expand-button size="24px" @click="showFinePrint = !showFinePrint" :externally-expanded="showFinePrint" />
    </div>
    <collapse-transition>
      <div v-if="showFinePrint" class="fine-print">
        הרני לאשר כי המידע יכול להימסר לחברות הנמנות עם קבוצת
        מיטב השקעות בע"מ (להלן: ״הקבוצה״) וגורמים
        נוספים, בין היתר, לצורכי שיווק ופרסום של מוצרים ושירותים
        פיננסיים או אחרים מטעם החברה או חברות קשורות לה הנמנות
        עם הקבוצה, בין בדרך של שירותי דיוור ישיר ובין כל אמצעי
        אחר, לרבות מסרונים, דוא"ל, פקסימיליה ומערכות חיוג
        אוטומטיות. ידוע לי כי אוכל לחזור מהסכמתי זו בכל עת ע"י פניה
        לחברה בטלפון 3366* שלוחה 3.
      </div>
    </collapse-transition>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import DefaultCheckbox from '@/components/styled/DefaultCheckbox';
import ExpandButton from '@/components/styled/ExpandButton';

export default {
  name: 'AgreeToReceiveMail',
  components: { CollapseTransition: BaseUI.CollapseTransition, ExpandButton, DefaultCheckbox },
  props: {
    agreeToReceiveMailFromMeitav: Boolean,
  },
  data() {
    return {
      showFinePrint: false,
    };
  },
  mounted() {
    this.showFinePrint = this.agreeToReceiveMailFromMeitav;
  },
  watch: {
    agreeToReceiveMailFromMeitav(newValue, oldValue) {
      this.showFinePrint = newValue;
    },
  },
};
</script>

<style scoped lang="scss">
.fine-print {
  margin-top: 10px;
}
</style>
